<template>
  <div class="content">
    <b-row>
      <b-col sm="12">
        <h4 class="text-center">Informatii utile</h4>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Info'
}
</script>

<style lang="scss" scoped>

</style>
